import {
  GOOGLE_DRIVE_TAB_KEY,
  useGoogleDrivePlugin,
  useYoutubeUrlPlugin,
  useZoomPlugin,
  YOUTUBE_URL_TAB_KEY,
  ZOOM_TAB_KEY,
} from '@sparemin/media-import';
import React from 'react';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import MediaImporterOverlay from '../MediaImporterOverlay';

export interface DefaultMediaUploadModalContentsProps {}

const DefaultMediaUploadModalContents: React.FC<DefaultMediaUploadModalContentsProps> = () => {
  const { params, onHide } = useConnectedModal('MediaUpload');

  const { uploadContext, mediaImportOption } = params || {};

  return (
    <MediaImporterOverlay
      {...{ uploadContext, onHide }}
      mediaImporterProps={{
        defaultSelectedTabKey: {
          googleDrive: GOOGLE_DRIVE_TAB_KEY,
          zoom: ZOOM_TAB_KEY,
          youtube: YOUTUBE_URL_TAB_KEY,
        }[mediaImportOption],
        plugins: [
          useGoogleDrivePlugin(),
          useZoomPlugin(),
          useYoutubeUrlPlugin(),
        ],
      }}
    />
  );
};

export default DefaultMediaUploadModalContents;
